/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './template-column-editor-dialog.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../template-field-list-item/template-field-list-item.component.ngfactory';
import * as i3 from '@angular/material';
import * as i4 from '../../../../../../app/modules/report/components/template-field-list-item/template-field-list-item.component';
import * as i5 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i6 from '@angular/common';
import * as i7 from '../../../utilities/components/small-spinner/small-spinner.component.ngfactory';
import * as i8 from '../../../../../../app/modules/utilities/components/small-spinner/small-spinner.component';
import * as i9 from '@angular/cdk/overlay';
import * as i10 from '@angular/cdk/scrolling';
import * as i11 from '@angular/cdk/platform';
import * as i12 from '@angular/cdk/bidi';
import * as i13 from '../../../../../../app/modules/report/components/template-column-editor-dialog/template-column-editor-dialog.component';
import * as i14 from '@angular/forms';
import * as i15 from '../../../../../../app/modules/report/services/report-formula-test/report-formula-test.service';
const styles_TemplateColumnEditorDialogComponent:any[] = [i0.styles];
export const RenderType_TemplateColumnEditorDialogComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TemplateColumnEditorDialogComponent,data:{}});
function View_TemplateColumnEditorDialogComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'app-template-field-list-item',
      [['class','mat-line'],['mdLine','']],(null as any),[[(null as any),'reportTemplateFieldChange'],
          [(null as any),'onRemove']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('reportTemplateFieldChange' === en)) {
          const pd_0:any = ((<any>(_co.reportTemplateColumn.report_template_fields[_v.context.index] = $event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('reportTemplateFieldChange' === en)) {
          const pd_1:any = ((<any>_co.changed()) !== false);
          ad = (pd_1 && ad);
        }
        if (('onRemove' === en)) {
          const pd_2:any = ((<any>_co.removeField(_v.context.index)) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },i2.View_TemplateFieldListItemComponent_0,i2.RenderType_TemplateFieldListItemComponent)),
      i1.ɵdid(1,16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(2,16384,(null as any),
          0,i3.MdLine,([] as any[]),(null as any),(null as any)),i1.ɵdid(3,114688,
          (null as any),0,i4.TemplateFieldListItemComponent,([] as any[]),{reportTemplateField:[0,
              'reportTemplateField']},{reportTemplateFieldChange:'reportTemplateFieldChange',
              onRemove:'onRemove'}),(_l()(),i1.ɵted(-1,(null as any),['\n  ']))],(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.reportTemplateColumn.report_template_fields[_v.context.index];
    _ck(_v,3,0,currVal_0);
  },(null as any));
}
function View_TemplateColumnEditorDialogComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),7,'md-list',[['class',
      'mat-list'],['role','list']],(null as any),(null as any),(null as any),i5.View_MdList_0,
      i5.RenderType_MdList)),i1.ɵdid(1,16384,(null as any),0,i3.MdPrefixRejector,[[2,
      i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(2,49152,(null as any),0,i3.MdList,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(3,16384,(null as any),0,i3.MdListCssMatStyler,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵted(-1,0,['\n  '])),(_l()(),i1.ɵand(16777216,
          (null as any),0,1,(null as any),View_TemplateColumnEditorDialogComponent_2)),
      i1.ɵdid(6,802816,(null as any),0,i6.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,
          0,['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.reportTemplateColumn.report_template_fields;
    _ck(_v,6,0,currVal_0);
  },(null as any));
}
function View_TemplateColumnEditorDialogComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-small-spinner',
      ([] as any[]),(null as any),(null as any),(null as any),i7.View_SmallSpinnerComponent_0,
      i7.RenderType_SmallSpinnerComponent)),i1.ɵdid(1,114688,(null as any),0,i8.SmallSpinnerComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
function View_TemplateColumnEditorDialogComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'md-icon',[['class',
      'mat-icon'],['color','warn'],['role','img']],(null as any),(null as any),(null as any),
      i5.View_MdIcon_0,i5.RenderType_MdIcon)),i1.ɵdid(1,16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(2,638976,(null as any),0,i3.MdIcon,[i1.Renderer2,i1.ElementRef,i3.MdIconRegistry,
          [8,(null as any)]],{color:[0,'color']},(null as any)),(_l()(),i1.ɵted(-1,
          0,['close']))],(_ck,_v) => {
    const currVal_0:any = 'warn';
    _ck(_v,2,0,currVal_0);
  },(null as any));
}
function View_TemplateColumnEditorDialogComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'md-icon',[['class',
      'mat-icon'],['color','accent'],['role','img']],(null as any),(null as any),(null as any),
      i5.View_MdIcon_0,i5.RenderType_MdIcon)),i1.ɵdid(1,16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(2,638976,(null as any),0,i3.MdIcon,[i1.Renderer2,i1.ElementRef,i3.MdIconRegistry,
          [8,(null as any)]],{color:[0,'color']},(null as any)),(_l()(),i1.ɵted(-1,
          0,['check']))],(_ck,_v) => {
    const currVal_0:any = 'accent';
    _ck(_v,2,0,currVal_0);
  },(null as any));
}
function View_TemplateColumnEditorDialogComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),21,'div',[['class',
      'test-area']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_TemplateColumnEditorDialogComponent_4)),
      i1.ɵdid(3,16384,(null as any),0,i6.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TemplateColumnEditorDialogComponent_5)),
      i1.ɵdid(6,16384,(null as any),0,i6.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TemplateColumnEditorDialogComponent_6)),
      i1.ɵdid(9,16384,(null as any),0,i6.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵeld(11,16777216,(null as any),(null as any),9,'div',[['class','btn-test'],
          ['mdTooltip','Test the formula above to make sure it works'],['mdTooltipPosition',
              'above']],(null as any),[[(null as any),'longpress'],[(null as any),
          'touchend']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('longpress' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,13).show()) !== false);
          ad = (pd_0 && ad);
        }
        if (('touchend' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,13).hide(1500)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(12,16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(13,147456,(null as any),0,i3.MdTooltip,[i9.Overlay,i1.ElementRef,i10.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i11.Platform,i3.MD_TOOLTIP_SCROLL_STRATEGY,
          [2,i12.Directionality]],{position:[0,'position'],message:[1,'message']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(15,
          0,(null as any),(null as any),4,'button',[['class','mat-raised-button'],
              ['color','primary'],['md-raised-button','']],[[8,'disabled',0]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.testFormula()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i5.View_MdButton_0,i5.RenderType_MdButton)),i1.ɵdid(16,16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(17,180224,(null as any),0,i3.MdButton,
          [i1.Renderer2,i1.ElementRef,i11.Platform,i3.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(18,16384,(null as any),0,i3.MdRaisedButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(-1,0,['Test the formula'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.waitingOnTest;
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = ((_co.status == 'fail') && !_co.waitingOnTest);
    _ck(_v,6,0,currVal_1);
    const currVal_2:any = ((_co.status == 'success') && !_co.waitingOnTest);
    _ck(_v,9,0,currVal_2);
    const currVal_3:any = 'above';
    const currVal_4:any = 'Test the formula above to make sure it works';
    _ck(_v,13,0,currVal_3,currVal_4);
    const currVal_6:any = 'primary';
    _ck(_v,17,0,currVal_6);
  },(_ck,_v) => {
    const currVal_5:any = (i1.ɵnov(_v,17).disabled || (null as any));
    _ck(_v,15,0,currVal_5);
  });
}
export function View_TemplateColumnEditorDialogComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),19,'md-form-field',
      [['class','value-field mat-input-container mat-form-field']],[[2,'mat-input-invalid',
          (null as any)],[2,'mat-form-field-invalid',(null as any)],[2,'mat-focused',
          (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
          [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
              (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
      [[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,2)._control.focus()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i5.View_MdFormField_0,i5.RenderType_MdFormField)),i1.ɵdid(1,16384,(null as any),
      0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(2,7389184,(null as any),6,i3.MdFormField,[i1.ElementRef,
      i1.ChangeDetectorRef,[2,i3.MD_PLACEHOLDER_GLOBAL_OPTIONS]],(null as any),(null as any)),
      i1.ɵqud(335544320,1,{_control:0}),i1.ɵqud(335544320,2,{_placeholderChild:0}),
      i1.ɵqud(603979776,3,{_errorChildren:1}),i1.ɵqud(603979776,4,{_hintChildren:1}),
      i1.ɵqud(603979776,5,{_prefixChildren:1}),i1.ɵqud(603979776,6,{_suffixChildren:1}),
      (_l()(),i1.ɵted(-1,1,['\n  '])),(_l()(),i1.ɵeld(10,0,(null as any),1,8,'input',
          [['class','mat-input-element'],['mdInput',''],['placeholder','Column Name']],
          [[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,'aria-describedby',
              0],[1,'aria-invalid',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i13.TemplateColumnEditorDialogComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,12)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,12).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,12)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,12)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,16)._focusChanged(false)) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,16)._focusChanged(true)) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,16)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.reportTemplateColumn.name = $event)) !== false);
              ad = (pd_7 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_8:any = ((<any>_co.changed()) !== false);
              ad = (pd_8 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(11,16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(12,16384,(null as any),0,i14.DefaultValueAccessor,[i1.Renderer2,i1.ElementRef,
          [2,i14.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),i1.ɵprd(1024,
          (null as any),i14.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i14.DefaultValueAccessor]),i1.ɵdid(14,671744,(null as any),0,i14.NgModel,
          [[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i14.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i14.NgControl,(null as any),[i14.NgModel]),i1.ɵdid(16,933888,(null as any),
          0,i3.MdInput,[i1.ElementRef,i1.Renderer2,i11.Platform,[2,i14.NgControl],
              [2,i14.NgForm],[2,i14.FormGroupDirective],[2,i3.MD_ERROR_GLOBAL_OPTIONS]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵdid(17,16384,(null as any),
          0,i14.NgControlStatus,[i14.NgControl],(null as any),(null as any)),i1.ɵprd(2048,
          [[1,4]],i3.MdFormFieldControl,(null as any),[i3.MdInput]),(_l()(),i1.ɵted(-1,
          1,['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵeld(21,
          0,(null as any),(null as any),19,'md-form-field',[['class','value-field mat-input-container mat-form-field']],
          [[2,'mat-input-invalid',(null as any)],[2,'mat-form-field-invalid',(null as any)],
              [2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],[2,
                  'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,23)._control.focus()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i5.View_MdFormField_0,i5.RenderType_MdFormField)),i1.ɵdid(22,16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(23,7389184,(null as any),6,i3.MdFormField,
          [i1.ElementRef,i1.ChangeDetectorRef,[2,i3.MD_PLACEHOLDER_GLOBAL_OPTIONS]],
          (null as any),(null as any)),i1.ɵqud(335544320,7,{_control:0}),i1.ɵqud(335544320,
          8,{_placeholderChild:0}),i1.ɵqud(603979776,9,{_errorChildren:1}),i1.ɵqud(603979776,
          10,{_hintChildren:1}),i1.ɵqud(603979776,11,{_prefixChildren:1}),i1.ɵqud(603979776,
          12,{_suffixChildren:1}),(_l()(),i1.ɵted(-1,1,['\n  '])),(_l()(),i1.ɵeld(31,
          0,(null as any),1,8,'textarea',[['class','mat-input-element'],['mdInput',
              ''],['placeholder','Description']],[[8,'id',0],[8,'placeholder',0],[8,
              'disabled',0],[8,'required',0],[1,'aria-describedby',0],[1,'aria-invalid',
              0],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,
              'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
              (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'ngModelChange'],[(null as any),'input'],[(null as any),
              'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend'],
              [(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i13.TemplateColumnEditorDialogComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,33)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,33).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,33)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,33)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,37)._focusChanged(false)) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,37)._focusChanged(true)) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,37)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.reportTemplateColumn.description = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(32,16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(33,16384,(null as any),0,i14.DefaultValueAccessor,[i1.Renderer2,i1.ElementRef,
          [2,i14.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),i1.ɵprd(1024,
          (null as any),i14.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i14.DefaultValueAccessor]),i1.ɵdid(35,671744,(null as any),0,i14.NgModel,
          [[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i14.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i14.NgControl,(null as any),[i14.NgModel]),i1.ɵdid(37,933888,(null as any),
          0,i3.MdInput,[i1.ElementRef,i1.Renderer2,i11.Platform,[2,i14.NgControl],
              [2,i14.NgForm],[2,i14.FormGroupDirective],[2,i3.MD_ERROR_GLOBAL_OPTIONS]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵdid(38,16384,(null as any),
          0,i14.NgControlStatus,[i14.NgControl],(null as any),(null as any)),i1.ɵprd(2048,
          [[7,4]],i3.MdFormFieldControl,(null as any),[i3.MdInput]),(_l()(),i1.ɵted(-1,
          1,['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵeld(42,
          0,(null as any),(null as any),20,'div',[['class','toolbar']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['\n  '])),(_l()(),i1.ɵeld(44,0,(null as any),(null as any),
          1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted(-1,(null as any),['Fields'])),(_l()(),i1.ɵted(-1,
          (null as any),['\n  '])),(_l()(),i1.ɵeld(47,16777216,(null as any),(null as any),
          14,'div',[['class','btn'],['mdTooltip','Add a field to this column'],['mdTooltipPosition',
              'left']],(null as any),[[(null as any),'longpress'],[(null as any),'touchend']],
          (_v,en,$event) => {
            var ad:boolean = true;
            if (('longpress' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,49).show()) !== false);
              ad = (pd_0 && ad);
            }
            if (('touchend' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,49).hide(1500)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(48,16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49,147456,(null as any),0,i3.MdTooltip,[i9.Overlay,i1.ElementRef,i10.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i11.Platform,i3.MD_TOOLTIP_SCROLL_STRATEGY,
          [2,i12.Directionality]],{position:[0,'position'],message:[1,'message']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(51,
          0,(null as any),(null as any),9,'button',[['class','mat-mini-fab'],['md-mini-fab',
              '']],[[8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i13.TemplateColumnEditorDialogComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.newField()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i5.View_MdButton_0,i5.RenderType_MdButton)),i1.ɵdid(52,16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(53,180224,(null as any),0,i3.MdButton,
          [i1.Renderer2,i1.ElementRef,i11.Platform,i3.FocusOriginMonitor],(null as any),
          (null as any)),i1.ɵdid(54,16384,(null as any),0,i3.MdMiniFab,[[2,i3.MdButton],
          [8,(null as any)]],(null as any),(null as any)),(_l()(),i1.ɵted(-1,0,['\n      '])),
      (_l()(),i1.ɵeld(56,0,(null as any),0,3,'md-icon',[['class','mat-icon'],['role',
          'img']],(null as any),(null as any),(null as any),i5.View_MdIcon_0,i5.RenderType_MdIcon)),
      i1.ɵdid(57,16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(58,638976,(null as any),
          0,i3.MdIcon,[i1.Renderer2,i1.ElementRef,i3.MdIconRegistry,[8,(null as any)]],
          (null as any),(null as any)),(_l()(),i1.ɵted(-1,0,['add'])),(_l()(),i1.ɵted(-1,
          0,['\n    '])),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),
          i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TemplateColumnEditorDialogComponent_1)),
      i1.ɵdid(65,16384,(null as any),0,i6.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n\n'])),
      (_l()(),i1.ɵeld(67,0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['Formula'])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),
          i1.ɵeld(70,0,(null as any),(null as any),19,'md-form-field',[['class','example-full-width mat-input-container mat-form-field']],
              [[2,'mat-input-invalid',(null as any)],[2,'mat-form-field-invalid',(null as any)],
                  [2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
                  [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,
                      'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
                      (null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
                  'click']],(_v,en,$event) => {
                var ad:boolean = true;
                if (('click' === en)) {
                  const pd_0:any = ((<any>i1.ɵnov(_v,72)._control.focus()) !== false);
                  ad = (pd_0 && ad);
                }
                return ad;
              },i5.View_MdFormField_0,i5.RenderType_MdFormField)),i1.ɵdid(71,16384,
          (null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(72,7389184,(null as any),
          6,i3.MdFormField,[i1.ElementRef,i1.ChangeDetectorRef,[2,i3.MD_PLACEHOLDER_GLOBAL_OPTIONS]],
          (null as any),(null as any)),i1.ɵqud(335544320,13,{_control:0}),i1.ɵqud(335544320,
          14,{_placeholderChild:0}),i1.ɵqud(603979776,15,{_errorChildren:1}),i1.ɵqud(603979776,
          16,{_hintChildren:1}),i1.ɵqud(603979776,17,{_prefixChildren:1}),i1.ɵqud(603979776,
          18,{_suffixChildren:1}),(_l()(),i1.ɵted(-1,1,['\n  '])),(_l()(),i1.ɵeld(80,
          0,(null as any),1,8,'input',[['class','mat-input-element'],['mdInput',''],
              ['placeholder','Formula']],[[8,'id',0],[8,'placeholder',0],[8,'disabled',
              0],[8,'required',0],[1,'aria-describedby',0],[1,'aria-invalid',0],[2,
              'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
              'ngModelChange'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
              'compositionstart'],[(null as any),'compositionend'],[(null as any),
              'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i13.TemplateColumnEditorDialogComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,82)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,82).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,82)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,82)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,86)._focusChanged(false)) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,86)._focusChanged(true)) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,86)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.reportTemplateColumn.formula = $event)) !== false);
              ad = (pd_7 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_8:any = ((<any>_co.changed()) !== false);
              ad = (pd_8 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(81,16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(82,16384,(null as any),0,i14.DefaultValueAccessor,[i1.Renderer2,i1.ElementRef,
          [2,i14.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),i1.ɵprd(1024,
          (null as any),i14.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i14.DefaultValueAccessor]),i1.ɵdid(84,671744,(null as any),0,i14.NgModel,
          [[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i14.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i14.NgControl,(null as any),[i14.NgModel]),i1.ɵdid(86,933888,(null as any),
          0,i3.MdInput,[i1.ElementRef,i1.Renderer2,i11.Platform,[2,i14.NgControl],
              [2,i14.NgForm],[2,i14.FormGroupDirective],[2,i3.MD_ERROR_GLOBAL_OPTIONS]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵdid(87,16384,(null as any),
          0,i14.NgControlStatus,[i14.NgControl],(null as any),(null as any)),i1.ɵprd(2048,
          [[13,4]],i3.MdFormFieldControl,(null as any),[i3.MdInput]),(_l()(),i1.ɵted(-1,
          1,['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_TemplateColumnEditorDialogComponent_3)),
      i1.ɵdid(92,16384,(null as any),0,i6.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n'])),
      (_l()(),i1.ɵeld(94,0,(null as any),(null as any),23,'div',[['class','toolbar']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(96,16777216,(null as any),
          (null as any),9,'div',[['class','btn'],['mdTooltip','Cancel All changes made to this column'],
              ['mdTooltipPosition','above']],(null as any),[[(null as any),'longpress'],
              [(null as any),'touchend']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('longpress' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,98).show()) !== false);
              ad = (pd_0 && ad);
            }
            if (('touchend' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,98).hide(1500)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(97,16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(98,147456,(null as any),0,i3.MdTooltip,[i9.Overlay,i1.ElementRef,i10.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i11.Platform,i3.MD_TOOLTIP_SCROLL_STRATEGY,
          [2,i12.Directionality]],{position:[0,'position'],message:[1,'message']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(100,
          0,(null as any),(null as any),4,'button',[['class','mat-raised-button'],
              ['color','warn'],['md-raised-button','']],[[8,'disabled',0]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i13.TemplateColumnEditorDialogComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.cancel()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i5.View_MdButton_0,i5.RenderType_MdButton)),i1.ɵdid(101,16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(102,180224,(null as any),0,i3.MdButton,
          [i1.Renderer2,i1.ElementRef,i11.Platform,i3.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(103,16384,(null as any),0,i3.MdRaisedButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(-1,0,['Cancel'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n  '])),(_l()(),i1.ɵeld(107,16777216,(null as any),(null as any),9,'div',
          [['class','btn'],['mdTooltip','Save this column. Test the formula before saving'],
              ['mdTooltipPosition','above']],(null as any),[[(null as any),'longpress'],
              [(null as any),'touchend']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('longpress' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,109).show()) !== false);
              ad = (pd_0 && ad);
            }
            if (('touchend' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,109).hide(1500)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(108,16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(109,147456,(null as any),0,i3.MdTooltip,[i9.Overlay,i1.ElementRef,i10.ScrollDispatcher,
          i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i11.Platform,i3.MD_TOOLTIP_SCROLL_STRATEGY,
          [2,i12.Directionality]],{position:[0,'position'],message:[1,'message']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(111,
          0,(null as any),(null as any),4,'button',[['class','mat-raised-button'],
              ['color','accent'],['md-raised-button','']],[[8,'disabled',0]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i13.TemplateColumnEditorDialogComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.save()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i5.View_MdButton_0,i5.RenderType_MdButton)),i1.ɵdid(112,16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(113,180224,(null as any),0,i3.MdButton,
          [i1.Renderer2,i1.ElementRef,i11.Platform,i3.FocusOriginMonitor],{disabled:[0,
              'disabled'],color:[1,'color']},(null as any)),i1.ɵdid(114,16384,(null as any),
          0,i3.MdRaisedButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted(-1,0,['Save'])),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        var _co:i13.TemplateColumnEditorDialogComponent = _v.component;
        const currVal_23:any = _co.reportTemplateColumn.name;
        _ck(_v,14,0,currVal_23);
        const currVal_24:any = 'Column Name';
        _ck(_v,16,0,currVal_24);
        const currVal_48:any = _co.reportTemplateColumn.description;
        _ck(_v,35,0,currVal_48);
        const currVal_49:any = 'Description';
        _ck(_v,37,0,currVal_49);
        const currVal_50:any = 'left';
        const currVal_51:any = 'Add a field to this column';
        _ck(_v,49,0,currVal_50,currVal_51);
        _ck(_v,58,0);
        const currVal_53:any = _co.reportTemplateColumn.report_template_fields;
        _ck(_v,65,0,currVal_53);
        const currVal_77:any = _co.reportTemplateColumn.formula;
        _ck(_v,84,0,currVal_77);
        const currVal_78:any = 'Formula';
        _ck(_v,86,0,currVal_78);
        const currVal_79:any = (_co.reportTemplateColumn.report_template_fields.length != 0);
        _ck(_v,92,0,currVal_79);
        const currVal_80:any = 'above';
        const currVal_81:any = 'Cancel All changes made to this column';
        _ck(_v,98,0,currVal_80,currVal_81);
        const currVal_83:any = 'warn';
        _ck(_v,102,0,currVal_83);
        const currVal_84:any = 'above';
        const currVal_85:any = 'Save this column. Test the formula before saving';
        _ck(_v,109,0,currVal_84,currVal_85);
        const currVal_87:boolean = !_co.canSave();
        const currVal_88:any = 'accent';
        _ck(_v,113,0,currVal_87,currVal_88);
      },(_ck,_v) => {
        const currVal_0:any = i1.ɵnov(_v,2)._control.errorState;
        const currVal_1:any = i1.ɵnov(_v,2)._control.errorState;
        const currVal_2:any = i1.ɵnov(_v,2)._control.focused;
        const currVal_3:any = i1.ɵnov(_v,2)._shouldForward('untouched');
        const currVal_4:any = i1.ɵnov(_v,2)._shouldForward('touched');
        const currVal_5:any = i1.ɵnov(_v,2)._shouldForward('pristine');
        const currVal_6:any = i1.ɵnov(_v,2)._shouldForward('dirty');
        const currVal_7:any = i1.ɵnov(_v,2)._shouldForward('valid');
        const currVal_8:any = i1.ɵnov(_v,2)._shouldForward('invalid');
        const currVal_9:any = i1.ɵnov(_v,2)._shouldForward('pending');
        _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
            currVal_7,currVal_8,currVal_9);
        const currVal_10:any = i1.ɵnov(_v,16).id;
        const currVal_11:any = i1.ɵnov(_v,16).placeholder;
        const currVal_12:any = i1.ɵnov(_v,16).disabled;
        const currVal_13:any = i1.ɵnov(_v,16).required;
        const currVal_14:any = (i1.ɵnov(_v,16)._ariaDescribedby || (null as any));
        const currVal_15:any = i1.ɵnov(_v,16).errorState;
        const currVal_16:any = i1.ɵnov(_v,17).ngClassUntouched;
        const currVal_17:any = i1.ɵnov(_v,17).ngClassTouched;
        const currVal_18:any = i1.ɵnov(_v,17).ngClassPristine;
        const currVal_19:any = i1.ɵnov(_v,17).ngClassDirty;
        const currVal_20:any = i1.ɵnov(_v,17).ngClassValid;
        const currVal_21:any = i1.ɵnov(_v,17).ngClassInvalid;
        const currVal_22:any = i1.ɵnov(_v,17).ngClassPending;
        _ck(_v,10,1,[currVal_10,currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,
            currVal_16,currVal_17,currVal_18,currVal_19,currVal_20,currVal_21,currVal_22]);
        const currVal_25:any = i1.ɵnov(_v,23)._control.errorState;
        const currVal_26:any = i1.ɵnov(_v,23)._control.errorState;
        const currVal_27:any = i1.ɵnov(_v,23)._control.focused;
        const currVal_28:any = i1.ɵnov(_v,23)._shouldForward('untouched');
        const currVal_29:any = i1.ɵnov(_v,23)._shouldForward('touched');
        const currVal_30:any = i1.ɵnov(_v,23)._shouldForward('pristine');
        const currVal_31:any = i1.ɵnov(_v,23)._shouldForward('dirty');
        const currVal_32:any = i1.ɵnov(_v,23)._shouldForward('valid');
        const currVal_33:any = i1.ɵnov(_v,23)._shouldForward('invalid');
        const currVal_34:any = i1.ɵnov(_v,23)._shouldForward('pending');
        _ck(_v,21,0,currVal_25,currVal_26,currVal_27,currVal_28,currVal_29,currVal_30,
            currVal_31,currVal_32,currVal_33,currVal_34);
        const currVal_35:any = i1.ɵnov(_v,37).id;
        const currVal_36:any = i1.ɵnov(_v,37).placeholder;
        const currVal_37:any = i1.ɵnov(_v,37).disabled;
        const currVal_38:any = i1.ɵnov(_v,37).required;
        const currVal_39:any = (i1.ɵnov(_v,37)._ariaDescribedby || (null as any));
        const currVal_40:any = i1.ɵnov(_v,37).errorState;
        const currVal_41:any = i1.ɵnov(_v,38).ngClassUntouched;
        const currVal_42:any = i1.ɵnov(_v,38).ngClassTouched;
        const currVal_43:any = i1.ɵnov(_v,38).ngClassPristine;
        const currVal_44:any = i1.ɵnov(_v,38).ngClassDirty;
        const currVal_45:any = i1.ɵnov(_v,38).ngClassValid;
        const currVal_46:any = i1.ɵnov(_v,38).ngClassInvalid;
        const currVal_47:any = i1.ɵnov(_v,38).ngClassPending;
        _ck(_v,31,1,[currVal_35,currVal_36,currVal_37,currVal_38,currVal_39,currVal_40,
            currVal_41,currVal_42,currVal_43,currVal_44,currVal_45,currVal_46,currVal_47]);
        const currVal_52:any = (i1.ɵnov(_v,53).disabled || (null as any));
        _ck(_v,51,0,currVal_52);
        const currVal_54:any = i1.ɵnov(_v,72)._control.errorState;
        const currVal_55:any = i1.ɵnov(_v,72)._control.errorState;
        const currVal_56:any = i1.ɵnov(_v,72)._control.focused;
        const currVal_57:any = i1.ɵnov(_v,72)._shouldForward('untouched');
        const currVal_58:any = i1.ɵnov(_v,72)._shouldForward('touched');
        const currVal_59:any = i1.ɵnov(_v,72)._shouldForward('pristine');
        const currVal_60:any = i1.ɵnov(_v,72)._shouldForward('dirty');
        const currVal_61:any = i1.ɵnov(_v,72)._shouldForward('valid');
        const currVal_62:any = i1.ɵnov(_v,72)._shouldForward('invalid');
        const currVal_63:any = i1.ɵnov(_v,72)._shouldForward('pending');
        _ck(_v,70,0,currVal_54,currVal_55,currVal_56,currVal_57,currVal_58,currVal_59,
            currVal_60,currVal_61,currVal_62,currVal_63);
        const currVal_64:any = i1.ɵnov(_v,86).id;
        const currVal_65:any = i1.ɵnov(_v,86).placeholder;
        const currVal_66:any = i1.ɵnov(_v,86).disabled;
        const currVal_67:any = i1.ɵnov(_v,86).required;
        const currVal_68:any = (i1.ɵnov(_v,86)._ariaDescribedby || (null as any));
        const currVal_69:any = i1.ɵnov(_v,86).errorState;
        const currVal_70:any = i1.ɵnov(_v,87).ngClassUntouched;
        const currVal_71:any = i1.ɵnov(_v,87).ngClassTouched;
        const currVal_72:any = i1.ɵnov(_v,87).ngClassPristine;
        const currVal_73:any = i1.ɵnov(_v,87).ngClassDirty;
        const currVal_74:any = i1.ɵnov(_v,87).ngClassValid;
        const currVal_75:any = i1.ɵnov(_v,87).ngClassInvalid;
        const currVal_76:any = i1.ɵnov(_v,87).ngClassPending;
        _ck(_v,80,1,[currVal_64,currVal_65,currVal_66,currVal_67,currVal_68,currVal_69,
            currVal_70,currVal_71,currVal_72,currVal_73,currVal_74,currVal_75,currVal_76]);
        const currVal_82:any = (i1.ɵnov(_v,102).disabled || (null as any));
        _ck(_v,100,0,currVal_82);
        const currVal_86:any = (i1.ɵnov(_v,113).disabled || (null as any));
        _ck(_v,111,0,currVal_86);
      });
}
export function View_TemplateColumnEditorDialogComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-template-column-editor-dialog',
      ([] as any[]),(null as any),(null as any),(null as any),View_TemplateColumnEditorDialogComponent_0,
      RenderType_TemplateColumnEditorDialogComponent)),i1.ɵdid(1,114688,(null as any),
      0,i13.TemplateColumnEditorDialogComponent,[i3.MdDialogRef,i3.MD_DIALOG_DATA,
          i3.MdDialog,i15.ReportFormulaTestService],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const TemplateColumnEditorDialogComponentNgFactory:i1.ComponentFactory<i13.TemplateColumnEditorDialogComponent> = i1.ɵccf('app-template-column-editor-dialog',
    i13.TemplateColumnEditorDialogComponent,View_TemplateColumnEditorDialogComponent_Host_0,
    {},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/report/components/template-column-editor-dialog/template-column-editor-dialog.component.ngfactory.ts